<template>
  <div class="body-wrapper">
    <Header :title="'Content'" />
    <UserDetails />
    <ActivityDetails :errors="errors" />
    <WorkoutDetails :errors="errors" />
    <PictureDetails />
    <div class="stage">
      <div class="stage-header">
        <h3>05: CONFIRM AND SUBMIT</h3>
      </div>
      <div class="stage-body">
        <div class="details activity-details">
          <p v-if="selectedUserId !== ''">Activity for {{selectedUser.first_name}} {{selectedUser.last_name}}</p>
          <p v-else class="error-text">No user selected</p>

          <p v-if="workoutDate !== '' && workoutTime !== ''">{{ formatDate(workoutDate) }}, {{ workoutTime }}</p>
          <p v-else class="error-text">No date selected</p>
          <div class="buttons">
            <button class="secondary-btn-dark">DISCARD</button>
            <button 
              v-if="workoutChoice !== 'post'"
              @click="createActivity" class="primary-btn">Create Activity</button>
            <button 
              v-else
              @click="createPost" class="primary-btn">Create Post</button>
          </div>
        </div>
      </div>
    </div>

    <UserModal />
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import { createActivity, createPost } from "@/api/requests";
import UserDetails from '../components/content_generator/UserDetails.vue';
import ActivityDetails from '../components/content_generator/ActivityDetails.vue';
import WorkoutDetails from '../components/content_generator/WorkoutDetails.vue';
import PictureDetails from '../components/content_generator/PictureDetails.vue';
import UserModal from '../components/modals/UserModal.vue';


export default {
  name: "Content",

  data() {
    return {
      activity: true,
      exercises: [],
      errors: {
        workoutName: false,
        workoutDescription: false,
        workoutTime: false,
        workoutDate: false,
        workoutChoice: false,
      },
    };
  },

  components: {
    Header,
    UserDetails,
    WorkoutDetails,
    ActivityDetails,
    PictureDetails,
    UserModal,
  },

  async mounted() {
    this.$store.dispatch('activity/loadUsers');
  },

  methods: {
    formatDate(date) {
      let dateObj = new Date(date);
      return dateObj.toDateString();
    },

    saveSet(reps, weight, exerciseId) {
      let set = {
        reps: reps,
        weight: weight,
        goldWeight: false,
        goldReps: false,
        silverWeight: false,
        silverReps: false,
        bronzeWeight: false,
        bronzeReps: false,
      };
      let ex = this.exercises.find(
        (exercise) => exercise.id === exerciseId
      );
      ex.sets.push(set);

      this.checkAchievements(ex);
    },

    resetSetAchievements(set) {
      set.goldWeight = false;
      set.goldReps = false;
      set.silverWeight = false;
      set.silverReps = false;
      set.bronzeWeight = false;
      set.bronzeReps = false;
    },

    resetExerciseAchievements(exercise) {
      exercise.currentGoldReps = exercise.goldReps;
      exercise.currentGoldWeight = exercise.goldWeight;
      exercise.currentSilverReps = exercise.silverReps;
      exercise.currentSilverWeight = exercise.silverWeight;
      exercise.currentBronzeReps = exercise.bronzeReps;
      exercise.currentBronzeWeight = exercise.bronzeWeight;
      exercise.currentMaxWeight = 0;
    },

    updateGoldWeight(exercise, set, allSets, weight) {
      allSets.forEach((currentSet) => {
        if (currentSet.goldWeight) {
          currentSet.goldWeight = false;
          currentSet.silverWeight = true;
        } else if (currentSet.silverWeight) {
          currentSet.silverWeight = false;
          currentSet.bronzeWeight = true;
        } else if (currentSet.bronzeWeight) {
          currentSet.bronzeWeight = false;
        }
      });
      set.goldWeight = true;
      exercise.currentGoldWeight = weight;
    },

    updateSilverWeight(exercise, set, allSets, weight) {
      allSets.forEach((currentSet) => {
        if (currentSet.silverWeight) {
          currentSet.silverWeight = false;
          currentSet.bronzeWeight = true;
        } else if (currentSet.bronzeWeight) {
          currentSet.bronzeWeight = false;
        }
      });
      set.silverWeight = true;
      exercise.currentSilverWeight = weight;
    },

    updateBronzeWeight(exercise, set, allSets, weight) {
      allSets.forEach((currentSet) => {
        if (currentSet.bronzeWeight) {
          currentSet.bronzeWeight = false;
        }
      });
      set.bronzeWeight = true;
      exercise.currentBronzeWeight = weight;
    },

    updateGoldReps(exercise, set, allSets, reps) {
      allSets.forEach((currentSet) => {
        if (currentSet.goldReps) {
          currentSet.goldReps = false;
          currentSet.silverReps = true;
        } else if (currentSet.silverReps) {
          currentSet.silverReps = false;
          currentSet.bronzeReps = true;
        } else if (currentSet.bronzeReps) {
          currentSet.bronzeReps = false;
        }
      });
      set.goldReps = true;
      exercise.currentGoldReps = reps;
    },

    updateSilverReps(exercise, set, allSets, reps) {
      allSets.forEach((currentSet) => {
        if (currentSet.silverReps) {
          currentSet.silverReps = false;
          currentSet.bronzeReps = true;
        } else if (currentSet.bronzeReps) {
          currentSet.bronzeReps = false;
        }
      });
      set.silverReps = true;
      exercise.currentSilverReps = reps;
    },

    updateBronzeReps(exercise, set, allSets, reps) {
      allSets.forEach((currentSet) => {
        if (currentSet.bronzeReps) {
          currentSet.bronzeReps = false;
        }
      });
      set.bronzeReps = true;
      exercise.currentBronzeReps = reps;
    },

    checkAchievements(exercise) {
      this.resetExerciseAchievements(exercise);
      exercise.sets.forEach((set) => {
        this.resetSetAchievements(set);
        let weightToCompare = set.weight;
        let repsToCompare = set.reps;

        if (weightToCompare > exercise.currentMaxWeight) {
          exercise.currentMaxWeight = weightToCompare;
        }

        if (repsToCompare > 0) {
          if (
            repsToCompare !== exercise.currentGoldReps &&
            repsToCompare !== exercise.currentSilverReps &&
            repsToCompare !== exercise.currentBronzeReps
          ) {
            if (parseInt(repsToCompare) > parseInt(exercise.currentGoldReps)) {
              this.updateGoldReps(exercise, set, exercise.sets, repsToCompare);
            } else if (
              parseInt(repsToCompare) > parseInt(exercise.currentSilverReps)
            ) {
              this.updateSilverReps(
                exercise,
                set,
                exercise.sets,
                repsToCompare
              );
            } else if (
              parseInt(repsToCompare) > parseInt(exercise.currentBronzeReps)
            ) {
              this.updateBronzeReps(
                exercise,
                set,
                exercise.sets,
                repsToCompare
              );
            }
          }
        }

        if (weightToCompare > 0) {
          if (
            weightToCompare !== exercise.currentGoldWeight &&
            weightToCompare !== exercise.currentSilverWeight &&
            weightToCompare !== exercise.currentBronzeWeight
          ) {
            if (
              parseInt(weightToCompare) > parseInt(exercise.currentGoldWeight)
            ) {
              this.updateGoldWeight(
                exercise,
                set,
                exercise.sets,
                weightToCompare
              );
            } else if (
              parseInt(weightToCompare) > parseInt(exercise.currentSilverWeight)
            ) {
              this.updateSilverWeight(
                exercise,
                set,
                exercise.sets,
                weightToCompare
              );
            } else if (
              parseInt(weightToCompare) > parseInt(exercise.currentBronzeWeight)
            ) {
              this.updateBronzeWeight(
                exercise,
                set,
                exercise.sets,
                weightToCompare
              );
            }
          }
        }
      });
    },

    addExercise(value) {
      value["sets"] = [];
      if (value['achievements'] !== null) {
        value["achievements"] = value["achievements"][0];
      } else {
        value["achievements"] = {};
      }
      value["currentGoldReps"] = value["achievements"]["gold_reps"] || 0;
      value["goldReps"] = value["achievements"]["gold_reps"] || 0;
      value["currentGoldWeight"] = value["achievements"]["gold_weight"] || 0;
      value["goldWeight"] = value["achievements"]["gold_weight"] || 0;
      value["currentSilverReps"] = value["achievements"]["silver_reps"] || 0;
      value["silverReps"] = value["achievements"]["silver_reps"] || 0;
      value["currentSilverWeight"] =
        value["achievements"]["silver_weight"] || 0;
      value["silverWeight"] = value["achievements"]["silver_weight"] || 0;
      value["currentBronzeReps"] = value["achievements"]["bronze_reps"] || 0;
      value["bronzeReps"] = value["achievements"]["bronze_reps"] || 0;
      value["currentBronzeWeight"] =
        value["achievements"]["bronze_weight"] || 0;
      value["bronzeWeight"] = value["achievements"]["bronze_weight"] || 0;
      value["currentMaxWeight"] = 0;
      this.exercises.push(value);
    },

    validateDetails() {
      this.errors = {
        workoutName: false,
        workoutDescription: false,
        workoutTime: false,
        workoutDate: false,
      };
      let valid = true;
      if (this.workoutName === '') {
        this.errors.workoutName = true;
        valid = false;
      }
      if (this.workoutTime === '') {
        this.errors.workoutTime = true;
        valid = false;
      }
      if (this.workoutDate === '') {
        this.errors.workoutDate = true;
        valid = false;
      }

      return valid;
    },

    getSetDetails(ex) {
      let setDetails = [];
      ex.sets.forEach((set) => {
        setDetails.push({
          set_number: "1",
          superset_letter: "",
          parent_set_number: "",
          reps: set.reps,
          weight: set.weight,
          dropset: false,
          superset: false,
          first_dropset: false,
          exercise_type: "Workout",
          time: "",
          distance: "",
          pace: "",
          gold_weight: set.goldWeight,
          silver_weight: set.silverWeight,
          bronze_weight: set.bronzeWeight,
          gold_reps: set.goldReps,
          silver_reps: set.silverReps,
          bronze_reps: set.bronzeReps,
        });
      });

      return setDetails;
    },

    getExerciseDetails() {
      let details = [];
      this.exercises.forEach((ex) => {
        const info = {
          exercises: [
            {
              id: ex.id,
              gold_weight: ex.currentGoldWeight,
              gold_reps: ex.currentGoldReps,
              silver_weight: ex.currentSilverWeight,
              silver_reps: ex.currentSilverReps,
              bronze_weight: ex.currentBronzeWeight,
              bronze_reps: ex.currentBronzeReps,
              current_max_weight: ex.currentMaxWeight,
            },
          ],
          sets: this.getSetDetails(ex),
          difficulty: 8,
        };
        details.push(info);
      });

      return details;
    },

    generateRandomWeight(exercise) {
      const equipment = exercise.equipment;
      let maxWeight = 0;
      let minWeight = 0;
      if (this.selectedUser.strength === 'weak') {
        switch(equipment) {
          case "Barbell":
            maxWeight = 40;
            minWeight = 20;
          case "Dumbbell":
            maxWeight = 7;
            minWeight = 3;
            break;
          case "EZ Bar":
            maxWeight = 20;
            minWeight = 10;
            break;
          case "Landmine":
            maxWeight = 40;
            minWeight = 20;
            break;
          case "Machine":
            maxWeight = 40;
            minWeight = 20;
            break;
          default:
            maxWeight = 0;
            minWeight = 0;
            break;
        }
      } else if (this.selectedUser.strength === 'strong') {
        switch(equipment) {
          case "Barbell":
            maxWeight = 100;
            minWeight = 90;
            break;
          case "Dumbbell":
            maxWeight = 20;
            minWeight = 12;
            break;
          case "EZ Bar":
            maxWeight = 50;
            minWeight = 30;
            break;
          case "Landmine":
            maxWeight = 80;
            minWeight = 50;
            break;
          case "Machine":
            maxWeight = 140;
            minWeight = 100;
            break;
          default:
            maxWeight = 0;
            minWeight = 0;
            break;
        }
      } else if (this.selectedUser.strength === 'very_strong') {
        switch(equipment) {
          case "Barbell":
            maxWeight = 200;
            minWeight = 150;
            break;
          case "Dumbbell":
            maxWeight = 40;
            minWeight = 30;
            break;
          case "EZ Bar":
            maxWeight = 70;
            minWeight = 40;
            break;
          case "Landmine":
            maxWeight = 160;
            minWeight = 80;
            break;
          case "Machine":
            maxWeight = 200;
            minWeight = 140;
            break;
          default:
            maxWeight = 0;
            minWeight = 0;
            break;
        }
      } else {
        // defaults to average
        switch(equipment) {
          case "Barbell":
            maxWeight = 80;
            minWeight = 60;
            break;
          case "Dumbbell":
            maxWeight = 30;
            minWeight = 18;
            break;
          case "EZ Bar":
            maxWeight = 40;
            minWeight = 20;
            break;
          case "Landmine":
            maxWeight = 80;
            minWeight = 40;
            break;
          case "Machine":
            maxWeight = 100;
            minWeight = 70;
            break;
          default:
            maxWeight = 0;
            minWeight = 0;
            break;
        }
      }

      let weight = Math.floor(Math.random() * (maxWeight - minWeight + 1)) + minWeight;
      return (weight % 5) >= 2.5 ? parseInt(weight / 5) * 5 + 5 : parseInt(weight / 5) * 5;
    },

    generateWorkout() {
      let selectedWorkout = this.workouts.find(workout => workout.id === this.workoutChoice);
      let exerciseData = JSON.parse(selectedWorkout.workout_activities);
      exerciseData.forEach(activity => {
        this.addExercise(activity.exercises[0]);
        activity.preview_sets.forEach(previewSet => {
          let weight = this.generateRandomWeight(activity.exercises[0]);
          this.saveSet(previewSet.reps, weight, activity.exercises[0].id);
        });
      });

      return this.getExerciseDetails();
    },

    generateStartTime() {
      let startHour = 0;
      let endHour = 23
      switch (this.workoutTime) {
        case 'morning':
          startHour = 5;
          endHour = 10
          break;
        case 'lunchtime':
          startHour = 11;
          endHour = 15
          break;
        case 'afternoon':
          startHour = 16;
          endHour = 18
          break;
        case 'night':
          startHour = 19;
          endHour = 23
          break;
      }
      let startTime = new Date(this.workoutDate);
      const hour = startHour + Math.random() * (endHour - startHour) | 0;
      const minute = 1 + Math.random() * (59 - 1) | 0;

      startTime.setHours(hour);
      startTime.setMinutes(minute);
      
      return startTime;
    },

    formatDateForSave(date) {
      return date.getFullYear() + '-' + ('0' + (date.getMonth()+1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + ' ' + ('0' + (date.getHours()+1)).slice(-2) + ":" + ('0' + (date.getMinutes()+1)).slice(-2) + ":00"; 
    },

    createActivity() {
      if (this.selectedUserId !== '' && this.validateDetails()) {
        // generate start time
        const startTime = this.generateStartTime();

        // generate duration
        let duration = Math.floor(Math.random() * (90 - 45 + 1)) + 45;
        let finishTime = new Date(startTime);
        finishTime.setMinutes(startTime.getMinutes() + duration);

        // get tags from description
        let tags = this.workoutDescription.match(/#\w+/g);
        if (tags) {
          tags = tags.map(tag => tag.slice(1));
        } else {
          tags = [];
        }

        let payload = {
          user_id: this.selectedUserId,
          title: this.workoutName,
          description: this.workoutDescription,
          start_time: this.formatDateForSave(startTime), // YYYY-MM-DD HH:MM:SS
          finish_time: this.formatDateForSave(finishTime),
          tags: tags.join(' '),
          visibility: "public",
          heart_rate_show: 'false',
          sponsored: 'false',
          intensity: this.workoutDifficulty,
          exercises: this.generateWorkout(),
        };

        let formData = new FormData();
        for (var key in payload) {
          if (key === "exercises") {
            for (let i = 0; i < payload['exercises'].length; i++) {
              let currentExercise = payload['exercises'][i];
              for (var subKey in currentExercise) {
                if (subKey === "sets" || subKey === "exercises") {
                  for (let j = 0; j < currentExercise[subKey].length; j++) {
                    let currentValue = currentExercise[subKey][j];
                    for (var subSubKey in currentValue) {
                      formData.append('exercises['+ i +']['+subKey+']['+ j +'][' + subSubKey + ']', currentValue[subSubKey]);
                    }  
                  }
                } else {
                  formData.append('exercises['+ i +']['+subKey+']', currentExercise[subKey]);
                }
              }
            }
          } else {
            formData.append(key, payload[key]);
          }
        }
        for(let i = 0; i < this.filesToUpload.length; i++) {
          if (i > 1) {
            break;
          }
          formData.append('files' + i.toString(), this.filesToUpload[i], this.filesToUpload[i].name);
        }
  
        createActivity(formData).then((response) => {
          this.selectedUser.last_post = this.formatDateForSave(startTime);
          this.exercises = [];
  
          this.$store.commit('activity/updateUserLocation');
          this.$store.commit('activity/resetActivity');
          window.scroll({ top: 0, behavior: 'smooth' });
        });
      } else {
        alert("Missing attributes");
      }
    },

    createPost() {
      if (this.selectedUserId !== '' && this.validateDetails()) {
        // generate start time
        const startTime = this.generateStartTime();

        // get tags from description
        let tags = this.workoutDescription.match(/#\w+/g);
        if (tags) {
          tags = tags.map(tag => tag.slice(1));
        } else {
          tags = [];
        }

        let payload = {
          user_id: this.selectedUserId,
          title: this.workoutName,
          description: this.workoutDescription,
          created: this.formatDateForSave(startTime),
          tags: tags.join(' '),
          visibility: "public",
          sponsored: 'false',
        };

        let formData = new FormData();
        for (var key in payload) {
          formData.append(key, payload[key]);
        }
        for(let i = 0; i < this.filesToUpload.length; i++) {
          if (i > 1) {
            break;
          }
          formData.append('files' + i.toString(), this.filesToUpload[i], this.filesToUpload[i].name);
        }

        createPost(formData).then((response) => {
          this.selectedUser.last_post = this.formatDateForSave(startTime);

          window.scroll({ top: 0, behavior: 'smooth' });
          this.$store.commit('activity/updateUserLocation');
          this.$store.commit('activity/resetActivity');
        });
      } else {
        alert("Missing attributes");
      }
    },
  },

  computed: {
    users: {
      get () {
        return this.$store.state.activity.users
      },
      set (value) {
        this.$store.commit('activity/addUser', value);
      }
    },
    
    createUser: {
      get () {
        return this.$store.state.activity.createUser
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'createUser'})
      }
    },

    workoutChoice() {
      return this.$store.state.activity.workoutChoice;
    },

    workoutTime() {
      return this.$store.state.activity.workoutTime;
    },

    workoutDate: {
      get () {
        return this.$store.state.activity.workoutDate
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'workoutDate'})
      }
    },
    
    workoutDescription() {
      return this.$store.state.activity.workoutDescription;
    },

    workoutName() {
      return this.$store.state.activity.workoutName;
    },

    selectedUserId() {
      return this.$store.state.activity.selectedUserId;
    },

    selectedUser() {
      return this.$store.state.activity.selectedUser;
    },
    
    workouts() {
      return this.$store.state.activity.workouts;
    },

    filesToUpload() {
      return this.$store.state.activity.filesToUpload;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.stage {
  width: 100%;
  padding-bottom: $spacing-base;

  .stage-header {
    padding: $spacing-base;
    display: flex;
    h3 {
      font-size: 14px;
      font-weight: 700;
      padding: 0;
      margin: 0;
      color: white;
    }
  }

  .stage-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: $spacing-base;

    .activity-details {
      max-width: 600px;
      
      p {
        color: $sec4;
        font-weight: 500;
        font-size: 14px;
        padding: 0;
        margin: 0;
      }
    }

    .details {
      padding: $spacing-base;
      padding-top: 0;
      display: flex;
      flex-direction: column;
    }
  }
}

.error-text {
  color: $red1 !important;
}
</style>
